import { ListboxItem } from '@ds';
import { ListboxItemHandlersType } from '@features/components/CaseFormBlocks/components/SearchableListbox';
import { getUnosId } from '@/utils/helpers';
import { Case, ReallocationCandidate } from '@/api/apis/case';

export const getTriggerContent = (
  selectedCase: Case | undefined,
  reAllocationCaseId: string | null | undefined,
  referenceCaseUnosId: string,
) => {
  if (selectedCase) {
    const {
      donorId,
      organType,
      reAllocationSequenceNumber,
      opoRequest,
      isExpeditedCase,
      laterality,
      duplicateCaseNumber,
    } = selectedCase;
    return (
      <div className="text-m-m">
        <div className="text-base-5">
          {getUnosId(
            donorId,
            organType,
            reAllocationSequenceNumber,
            opoRequest,
            isExpeditedCase,
            laterality,
            duplicateCaseNumber,
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="text-m-m">
      <div className="text-base-20">{reAllocationCaseId ? referenceCaseUnosId : 'Select Reference Case'}</div>
    </div>
  );
};

export const renderItem = (item: ReallocationCandidate, handlers: ListboxItemHandlersType) => {
  return (
    <ListboxItem key={item.caseId} textValue={item.caseName} {...handlers}>
      <div>{item.caseName}</div>
    </ListboxItem>
  );
};
